import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const ChatIcon: LucideIcon = forwardRef(({ size = 24, color = 'currentColor', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.7383 19.4358C14.9512 19.1503 14.2801 18.7808 13.7515 18.4344C12.5921 18.8834 11.3253 19.1305 10 19.1305C4.47715 19.1305 0 14.8479 0 9.56524C0 4.2825 4.47715 0 10 0C15.5228 0 20 4.2825 20 9.56524C20 11.5468 19.3691 13.3899 18.289 14.9175C18.2205 16.1806 18.914 17.3219 19.6338 18.3319C20.2643 19.2163 20.1061 19.9291 18.9305 19.9928C18.4036 20.0213 17.2639 19.9891 15.7383 19.4358ZM1.81818 9.56524C1.81818 5.243 5.48131 1.73913 10 1.73913C14.5187 1.73913 18.1818 5.243 18.1818 9.56524C18.1818 11.2612 17.6189 12.8288 16.6618 14.1098C16.2384 14.6767 16.4562 15.739 16.6015 16.3488C16.7425 16.9407 17.0484 17.5697 17.3505 18.0977C17.0613 18.031 16.7374 17.9381 16.3829 17.8096C15.5672 17.5137 14.8931 17.0978 14.4176 16.7487C14.1478 16.5506 13.785 16.5133 13.4773 16.6517C12.4231 17.1259 11.2452 17.3913 10 17.3913C5.48131 17.3913 1.81818 13.8875 1.81818 9.56524ZM6.39092 12.3848C6.24935 11.8432 6.69654 11.3045 7.27287 11.3042H12.7275C13.303 11.3045 13.7509 11.8411 13.6094 12.3826C13.1386 13.9027 11.6231 14.7826 10.0002 14.7826C8.43946 14.7826 6.79002 13.9119 6.39092 12.3848ZM14.0909 7.8261C14.0909 8.54645 13.4804 9.13045 12.7273 9.13045C11.9742 9.13045 11.3636 8.54645 11.3636 7.8261C11.3636 7.10573 11.9742 6.52175 12.7273 6.52175C13.4804 6.52175 14.0909 7.10573 14.0909 7.8261ZM7.27273 9.13045C8.02585 9.13045 8.63636 8.54645 8.63636 7.8261C8.63636 7.10573 8.02585 6.52175 7.27273 6.52175C6.51961 6.52175 5.90909 7.10573 5.90909 7.8261C5.90909 8.54645 6.51961 9.13045 7.27273 9.13045Z'
        fill={color}
      />
    </svg>
  )
})

ChatIcon.displayName = 'ChatIcon'
